import { Box, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Review_Slider as ReviewSliderData } from "~/core";
import { SliderArrow } from "~/icons";

type SliderPaginationProps = {
  data: ReviewSliderData;
  activeIndex: number;
  handleClick: (action: "prev" | "next" | number) => void;
};
export const SliderPagination: FC<SliderPaginationProps> = ({
  data,
  activeIndex,
  handleClick,
}) => {
  return (
    <>
      <Flex justify="center" gap={10} d={{ display: "hidden" }}>
        {data?.items?.map((_, index) => (
          <Box
            onClick={() => handleClick(index)}
            key={index}
            width={12}
            height={12}
            border={{ radius: "9999px" }}
            bg={
              activeIndex === index
                ? "surface-primary-hovered"
                : "surface-neutral-light"
            }
            className="transition-all duration-300"
          />
        ))}
      </Flex>
      <Box
        position={{ type: "absolute", top: "50%", left: "-38px", zIndex: 10 }}
        as="span"
        display="hidden"
        d={{ display: "block" }}
        className="cursor-pointer"
        onClick={() => handleClick("prev")}
      >
        <SliderArrow />
      </Box>

      <Box
        position={{ type: "absolute", top: "50%", right: "-38px", zIndex: 10 }}
        as="span"
        display="hidden"
        d={{ display: "block" }}
        onClick={() => handleClick("next")}
        className="rotate-180 cursor-pointer"
      >
        <SliderArrow />
      </Box>
    </>
  );
};
